import cookie from '@tencent/vft-common/cookie';
import login from '@tencent/vft-common/login';
import { createBossReporter } from '@tencent/vft-report';
import { createReporter } from '@tencent/vft-report/lib/reporter';
import { parseVueBindingValue } from '@tencent/vft-report/lib/util';
var reporter = createReporter({}, [createBossReporter({
  config: {
    event: {
      attaId: 'z9200003753',
      token: '2878173842'
    }
  },
  extraParams: function extraParams() {
    var params = {
      f_url: '/h5/login-panel/',
      f_logintype: '-',
      f_uid: '',
      f_appid: '',
      f_guid: cookie.get('guid') || cookie.get('video_guid'),
      f_omgid: cookie.get('video_omgid'),
      _dc: Math.random()
    };

    if (login.isLogin()) {
      params.f_logintype = login.loginType();
      params.f_vuid = login.getVuid();
      params.f_uid = login.getUid();

      if (!login.isPTLogin()) {
        params.f_appid = cookie.get(login.isNewQQLogin() ? 'vqq_appid' : 'appid');
      }
    }

    return params;
  }
})]);
export function handleDirectives(el, binding, hook) {
  reporter.runMiddleware(function (middleware) {
    middleware.useDirective(el, parseVueBindingValue(binding, hook));
  });
}
export default reporter;